import ReactDOM from "react-dom/client";
import { defaultShouldDehydrateQuery, Query, QueryClient } from "@tanstack/react-query";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "./theme";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { App } from "./App";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QUERY_CACHE_STORAGE_KEY } from "./api/session";
import { STAFF_PAY_QUERY_KEY } from "./screens/staff/utils/staffPayApi";
import { IMAGE_URL_QUERY_KEY } from "./api/useImage";

const isDevMode = process.env.NODE_ENV === "development" ? true : false;

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 1000 * 60 * 60 * 24, // 24 hours
            refetchOnWindowFocus: false,
        },
    },
});
const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: QUERY_CACHE_STORAGE_KEY,
});

const NOT_PERSISTED_QUERY_KEYS = [STAFF_PAY_QUERY_KEY, IMAGE_URL_QUERY_KEY];

const shouldPersistQuery = (query: Query) => {
    const isPersistable = defaultShouldDehydrateQuery(query) && !NOT_PERSISTED_QUERY_KEYS.includes(query.queryKey[0] as string);
    return isPersistable;
};

const appTheme = createTheme(theme);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <PersistQueryClientProvider
        client={queryClient}
        //@ts-ignore
        persistOptions={{
            persister,
            //@ts-ignore
            buster: isDevMode ? new Date() : __COMMIT_HASH__,
            dehydrateOptions: { shouldDehydrateQuery: shouldPersistQuery },
        }}
    >
        <ThemeProvider theme={appTheme}>
            <App />
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
);
